import React from 'react';
import { Snackbar, Alert, Typography } from '@mui/material';

export default function VerisafeSnackbar({ open, message, severity, onClose }) {
    // Determine duration based on severity and message content
    const getDuration = () => {
        if (severity === 'error') return 8000;
        if (severity === 'warning') return 10000; // Keep limit warnings visible longer
        
        // Safely check for 'Password' only if the message is a string
        if (typeof message === 'string' && message.includes('Password')) {
            return 12000;
        }
        
        return 4000; // Default success/info duration
    };

    return (
        <Snackbar
            open={open}
            // Keep errors on screen longer (8s) than success messages (4s), and passwords even longer (12s)
            autoHideDuration={getDuration()}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >

            <Alert
                onClose={onClose}
                severity={severity}
                variant="filled"
                sx={{
                    width: '100%',
                    boxShadow: 3,
                    alignItems: 'center'
                }}
            >
                <Typography
                    variant="body2"
                    component="div" // Required to allow <span> and <br> children
                    sx={{
                        whiteSpace: 'pre-line',
                        lineHeight: 1.6, // Adds breathing room between lines
                        fontWeight: severity === 'error' ? 500 : 400
                    }}
                >
                    {message}
                </Typography>
            </Alert>

        </Snackbar>
    );
}